export default [
  {
    label: "Home",
    iconClass: "fas fa-home",
    to: "/home",
  },
  {
    label: "About",
    iconClass: "fas fa-user",
    to: "/about",
  },
  // {
  //   label: "Portfolio",
  //   iconClass: "fas fa-briefcase",
  //   to: "/portfolio",
  // },
  {
    label: "Blog",
    iconClass: "fas fa-copy",
    to: "/blog",
  },
];
